import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SupportFallbackPage } from '@/features/membership/components/support-fallback-page'
import { appConfig } from '@/shared/config/app-config'

// Rendered by ProtectedRoute (as its `fallback`) when the session is lost or
// expired on a cancel-flow route. Native-app users arrive here via autologin in
// a webView and have no password, so the default external /login redirect is a
// dead end. This shows the same in-app error copy as the flow's own error step
// with a route to the PUBLIC /contact-support. No "go back to membership"
// button — that route is itself protected and would just bounce to /login.
export function CancelFlowAuthFallback() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <SupportFallbackPage
      title={t('unsubscription_cancelFlow_error_title_web')}
      subtitle={t('unsubscription_cancelFlow_error_subtitle_web')}
      onContactSupport={() =>
        navigate('/contact-support', {
          state: { subject: appConfig.supportTicketSubjects.cancellationFlow },
        })
      }
    />
  )
}
